export default __webpack_public_path__ + "static/Home-88a8e25b6eb28d7d177eef14d069b945.png";